import { createBrowserRouter } from "react-router-dom";

import { routeObjects } from "./routeObjects";

export const router = createBrowserRouter(routeObjects);
